import { TabsProvider, useTabsContext } from "./context";
import Tabs, { Tab, TabContainer } from "./Tabs";

export { Tab, TabsProvider, TabContainer, useTabsContext };

export default Tabs;
